import { cn } from '@/lib/utils';

interface ListDividerProps {
    className?: string;
}

export function ListDivider({ className }: ListDividerProps) {
    return (
        <div
            role="separator"
            aria-orientation="horizontal"
            className={cn('h-px w-full bg-grey-500', className)}
        />
    );
}
